module.exports = __webpack_public_path__ + "static/img/14.f381df94.png";